import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@app/environment';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith('http')) {
    return next(req);
  }

  return next(req.clone({ url: `${environment.API_URL}${req.url}` }));
};
